<template>
	<section class="main-content contentblocks" :class="!contentBlocksContent.length ? 'no-content' : 'has-content'">
		<div class="row row-header align-center white">
			<div v-if="contentBlocksContent.length">
				<h2 v-if="contentBlocksSubtitle">
					{{ contentBlocksSubtitle }}
				</h2>
				<div v-parse-links v-html="contentBlocksContent" />
			</div>
		</div>
		<div v-for="(block, index) in contentblocks" :key="block.ID" class="row contentblock">
			<div class="columns column6 contentblock-content" :class="index % 2 === 0 ? 'right' : 'left'">
				<h3>{{ block.header }}</h3>
				<div v-parse-links v-html="block.content" />
			</div>
			<div class="contentblock-image">
				<picture>
					<source v-if="block.imageWebp" :srcset="block.imageWebp" type="image/webp" />
					<source :srcset="block.image" />
					<img loading="lazy" :src="block.image" :alt="block.imageAlt" />
				</picture>
			</div>
		</div>
	</section>
</template>

<script setup>
defineProps({
	contentblocks: { type: Array, default: () => [] },
	contentBlocksContent: { type: String, default: '' },
	contentBlocksSubtitle: { type: String, default: '' },
});
</script>

<style lang="scss" scoped>
.contentblocks {
	background: var(--contentblock-background-color);
	padding: 75px 0 0;

	&.no-content {
		padding-top: 0;

		.row-header {
			margin: 0;
		}
	}

	a,
	:deep(a) {
		color: #fff;

		&:hover {
			text-decoration: underline;
		}
	}

	.button,
	:deep(.button) {
		text-decoration: none !important;
	}
}

.background-light {
	background: var(--alternating-background-color);
}

.contentblock {
	margin: 0 auto;
	position: relative;
	border-top: 1px solid #fff;
	width: 100%;
	max-width: 100%;

	&:nth-child(odd) {
		.contentblock-content {
			margin-left: calc(50% - 740px);
			margin-right: 0;
		}
	}
}

.row-header {
	max-width: 1000px;
	margin: 0 auto 55px;
}

.contentblock-image {
	position: absolute;
	top: 0;
	right: 0;
	bottom: 0;
	width: 50%;
	z-index: 1;
}

.contentblock-content {
	padding: 110px 80px;
	margin: 0 auto;
	position: relative;
	z-index: 2;
	color: #fff;
	max-width: 740px;
	margin-right: calc(50% - 740px);

	.button,
	:deep(.button) {
		color: #fff;
		border: 2px solid #fff;
		padding: 11px 22px 10px;
		background: none;

		&:hover {
			background: #fff;
			border-color: #fff;
			color: var(--contentblock-background-color);
		}
	}

	h3 {
		color: #fff;
	}
}

.row:nth-child(even) .contentblock-image {
	left: 0;
	right: auto;
}

.contentblock-image img {
	width: 100%;
	height: 100%;
	object-fit: cover;
}

@media (max-width: 1520px) {
	.contentblock-content {
		margin: auto !important;
	}
}

@media (max-width: 920px) {
	.contentblock-image {
		width: 100%;
		position: relative;
		inset: auto;
	}

	.contentblock {
		display: flex;
		flex-flow: wrap column-reverse;
	}

	.contentblock-content {
		margin: 0 auto 50px;
		padding: 50px 30px;
	}
}
</style>
